import { Link } from 'react-router-dom';
import { useInView } from '../../hooks/useInView';
import { Check, ShoppingBag, Star, Truck, RefreshCw, Leaf, Repeat } from 'lucide-react';
import { PRODUCT_IMAGES, SUBSCRIBE_PRICE } from '../../constants';

const bullets = [
'Supports semen volume naturally',
'Supports healthy libido & drive',
'Premium botanical extracts',
'60 capsules per bottle',
'Just 2 capsules daily',
'No artificial additives'];




const trustItems = [
  { icon: Truck, label: 'Free UK Delivery on 2+ bottles' },
  { icon: RefreshCw, label: '30-Day Money-Back Guarantee' },
  { icon: Leaf, label: 'Premium Plant-Based Formula' },
];

export default function ProductSection() {
  const [ref, inView] = useInView(0.1);

  return (
    <section
      data-testid="product-section"
      id="product"
      style={{ backgroundColor: '#FFFFFF', padding: '96px 0' }}>

      <div ref={ref} className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`text-center mb-4 fade-up ${inView ? 'visible' : ''}`}>
          <span className="overline">The Product</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-14 items-start mt-8">
          {/* Product Image */}
          <div className={`fade-up delay-1 ${inView ? 'visible' : ''}`}>
            <img
              src="https://customer-assets.emergentagent.com/job_reload-performance/artifacts/1ohi552i_Ingredients.png"
              alt="RELOAD Ingredients"
              data-testid="product-image"
              style={{ width: '100%', display: 'block', borderRadius: '20px' }}
            />
          </div>

          {/* Product Info */}
          <div className={`fade-up delay-2 ${inView ? 'visible' : ''}`}>
            <span className="overline block mb-3"></span>
            <h2 style={{
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 800,
              fontSize: 'clamp(1.8rem, 3vw, 2.6rem)',
              color: '#0D1A2E',
              letterSpacing: '-0.025em',
              lineHeight: 1.15,
              marginBottom: '14px'
            }}>
              Male Reproductive<br />Support Formula
            </h2>

            {/* Stars */}
            <div className="flex items-center gap-2 mb-5">
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="#1B3D7E" stroke="#1B3D7E" />)}
              </div>
              <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.8rem', color: '#64748B', fontWeight: 600 }}>4.9 / 5 (2,000+ reviews)</span>
            </div>

            <div className="flex items-baseline gap-3 mb-5">
              <span style={{ fontFamily: 'Outfit, sans-serif', fontSize: '2.2rem', fontWeight: 800, color: '#1B3D7E' }} className="!text-[#1B3D7E]">£24.99</span>
              <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.75rem', color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.12em' }}>60 Capsules / 30-day supply</span>
            </div>

            <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.92rem', color: '#64748B', lineHeight: 1.8, marginBottom: '22px' }}>
              RELOAD is formulated with a precise blend of natural botanical ingredients, designed to support the key aspects of male reproductive health — volume, libido, and vitality.
            </p>

            {/* Bullets */}
            <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '28px', listStyle: 'none' }}>
              {bullets.map((item) =>
              <li key={item} className="flex items-center gap-3" data-testid={`product-bullet-${item.substring(0, 20).replace(/\s+/g, '-').toLowerCase()}`}>
                  <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'rgba(27,61,126,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <Check size={11} style={{ color: '#1B3D7E' }} strokeWidth={2.5} />
                  </div>
                  <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.88rem', color: '#0D1A2E', fontWeight: 500 }}>{item}</span>
                </li>
              )}
            </ul>

            {/* Primary CTA */}
            <Link
              to="/shop"
              data-testid="product-buy-now"
              className="btn-blue gap-2 px-8 py-4 rounded-full text-sm"
              style={{ fontFamily: 'Manrope, sans-serif', display: 'inline-flex', width: '100%', justifyContent: 'center', marginBottom: '10px', textDecoration: 'none' }}>
              <ShoppingBag size={15} strokeWidth={2} style={{ marginRight: '6px' }} />
              Buy Now — £24.99
            </Link>

            {/* Subscribe nudge */}
            <Link
              to="/shop"
              data-testid="product-subscribe-link"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '7px',
                width: '100%',
                padding: '13px',
                border: '1.5px solid rgba(27,61,126,0.2)',
                borderRadius: '12px',
                textDecoration: 'none',
                backgroundColor: 'rgba(27,61,126,0.03)',
                marginBottom: '20px',
                transition: 'border-color 0.2s, background-color 0.2s',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#1B3D7E'; e.currentTarget.style.backgroundColor = 'rgba(27,61,126,0.07)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(27,61,126,0.2)'; e.currentTarget.style.backgroundColor = 'rgba(27,61,126,0.03)'; }}
            >
              <Repeat size={13} style={{ color: '#1B3D7E' }} strokeWidth={2} />
              <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.78rem', fontWeight: 700, color: '#1B3D7E' }}>
                Subscribe & Save — £{SUBSCRIBE_PRICE.toFixed(2)}/month
              </span>
              <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.68rem', color: '#94A3B8', fontWeight: 500 }}>
                · Included UK Delivery · Cancel anytime
              </span>
            </Link>

            {/* Trust indicators */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {trustItems.map(({ icon: Icon, label }) => (
                <div key={label} className="flex items-center gap-2">
                  <Icon size={13} style={{ color: '#1B3D7E', flexShrink: 0 }} strokeWidth={1.5} />
                  <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.78rem', color: '#64748B', fontWeight: 600 }}>{label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>);
}